import React from 'react'

const ViewIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none">
            <path d="M1 4.25C3 -0.0833332 9 -0.0833332 11 4.25" stroke="#5B5B5B" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M6.0013 6.58464C5.2649 6.58464 4.66797 5.9877 4.66797 5.2513C4.66797 4.5149 5.2649 3.91797 6.0013 3.91797C6.7377 3.91797 7.33464 4.5149 7.33464 5.2513C7.33464 5.9877 6.7377 6.58464 6.0013 6.58464Z" stroke="#5B5B5B" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default ViewIcon